<template>
	<div class="explain" >
	  <div class="rightWap">
	    <div class="myAccount zhanghuquxiao">
	      <h1>解除集团绑定<img src="/images/rightClose.png" @click="closeFloat" class="closePop"/></h1>
				
	      <dl class="information">
					
					<dt>验证码</dt>
					<dd>
						<ul>
						  <li>
								<input type="text" v-model="phonecode" />
								<input @click="sendPhoneCode" :disabled="phonecountdown>0" type="button" :value="phonecountdown?phonecountdown:'获取验证码'" :class="phonecountdown>0?'un':'sendBtn'" />
							</li>
						</ul>
					</dd>
	        
					
					<dt></dt>
					<dd>
						<ul >
						  <li>
								<input type="button" @click="quxiaoSubmit()" value="确定" class="sub"/>
							</li>
						</ul>
					</dd>
					
	      </dl>
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				phonecode: '',
				phonecountdown: 0,
				phonetimer: '',
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			if (this.$cookies.get('phonecountdown') && parseInt(this.$cookies.get('phonecountdown'))) {
				this.setPhoneCountdown(parseInt(this.$cookies.get('phonecountdown')));
			}
		},
		methods: {
			sendPhoneCode: function() {
				let _this = this;
				if (_this.phonecountdown > 0) {
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				_this.phonecountdown = 60;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/getUnbindCodeInfo',
						// responseType: 'json',
						params: {
							pnum: "-1"
						},
					})
					.then(function(response) {
						var text = response.data.data.data;
						var arr = text.split('_');
						var m = arr[1] == "1" ? "手机" : "邮箱";
						if (arr[0] == "-1") {
							_this.$message({
								message: '发送失败',
								type: 'warning'
							});
							_this.phonecountdown = 0;
						} else {
							_this.$message({
								message: '发送成功',
								type: 'success'
							});
							_this.setPhoneCountdown(60);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.phonecountdown = 0;
						_this.loadingMask = false;
						console.log(error);
					});
			},
			setPhoneCountdown: function(num) {
				let _this = this;
				_this.phonecountdown = num;
				clearInterval(_this.phonetimer);
				_this.phonetimer = setInterval(function() {
					// debugger;
					if (_this.phonecountdown > 1) {
						_this.phonecountdown--;
						_this.$cookies.set('phonecountdown', _this.phonecountdown, _this.phonecountdown);
					} else {
						_this.phonecountdown = 0;
						clearInterval(_this.phonetimer);
						_this.$cookies.remove('phonecountdown');
					}
				}, 1000);
			},
			quxiaoSubmit: function(){
				if(!this.phonecode){
					this.$message({
						message: '请填写验证码',
						type: 'warning'
					});
					return false;
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/Unbind',
						responseType: 'json',
						params: {
							uncode: this.phonecode
						},
					})
					.then(function(response) {
						var text = response.data.data.data
						if (text == "1") {
							_this.$alert('解绑成功！', '成功', {
								confirmButtonText: '确定',
							});

							_this.$track([
								['pagetype', '接触集团绑定']
							]);

							_this.closeFloat();
						} else {
							_this.$alert('解绑失败！', '失败', {
								confirmButtonText: '确定',
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},

		},
	}
</script>

<style>
</style>
